<script setup>
defineProps({
  info: {default: ""}
});
</script>

<template>
  <small class="form-text" style="display: block">
    <span v-if="info && Array.isArray(info)">
      {{ $t(...info) }}
    </span>
    <span v-else-if="info">
      {{ $t(info) }}
    </span>
  </small>
</template>
